import BaseModule from './BaseModule.js';

class CustomerAccessBlock extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/customer-access-blocks`, {
      params: { page, per_page, term },
    });
  }

  async remove(id) {
    return await this.delete(`/back-office/customer-access-blocks/${id}`);
  }

  async allow(id, payload = {}) {
    return await this.post(`/back-office/customer-access-blocks/${id}/allow`, payload);
  }

  async attempts(id, params = {}) {
    return await this.get(`/back-office/customer-access-blocks/${id}/attempts`, {
      params,
    });
  }
}

export default CustomerAccessBlock;
